<template>
    <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
            <v-btn :to="url" icon v-bind="attrs" v-on="on">
                <v-badge v-if="count" color="primary" :content="count">
                    <v-icon>mdi-calendar-account</v-icon>
                </v-badge>
                <v-icon v-else>mdi-calendar-account</v-icon>
            </v-btn>
        </template>
        <span>Mijn taken</span>
    </v-tooltip>
</template>

<script>
import moment from "moment/moment";
import User from "@/models/User/User.js";
import Task from "@/models/Task/Task.js";

export default {
    data() {
        return {
            count: 0,
        }
    },
    computed: {
        todayString() {
            return moment().format('YYYY-MM-DD');
        },
        url() {
            return '/tasks?user_ids[]=' + this.user.id + '&state=1&scheduled_before=' + this.todayString +
                '&sortBy[is_expired]=desc&sortBy[scheduled_at]=asc'
        },
        user() {
            return User.loggedInUser();
        },
    },
    methods: {
        async fetchTaskCount() {
            return Task.counts(1, this.user.id, null, this.todayString).then(result => {
                this.count = result ? Math.max(0,result.task_count): 0;
            });
        },

        updateCount(socketData) {
            if (socketData.user_id === this.user.id) {
                this.count = socketData.task_count;
            }

        }
    },
    sockets: {
        'task:user-tasks-count-updated'(socketData) {
            this.updateCount(socketData)
        },
    },
    mounted() {
        this.$socket.emit('room:join', 'tasks');
        this.fetchTaskCount();
    },
    beforeDestroy() {
        this.$socket.emit('room:leave', 'tasks');
    }
}
</script>
